export class VersionFilterViewT3Model {
    overallAssessmentId: number;
    interpretationId: number;
    filterType: string;
    templateId: number;
    versionType: string;
    summuryDetailsId: string;
    tab: number;
    constructor() {
      this.overallAssessmentId = 0;
      this.interpretationId = 0;
      this.filterType = "";
      this.templateId = 0;
      this.versionType = "";
      this.summuryDetailsId = "";
      this.tab = 0;
    }
}

export class VersionHistoryT3 {
    id: number;
    versionNumber: number;
    versionDate: Date;
    userId: string;

    constructor() {
        this.id = 0;
        this.versionNumber = 0;
        this.versionDate = new Date();
        this.userId = '';
    }
}

export class VersionHistoryT3ViewModel {
    data: VersionHistoryT3[];
    totalCount: number;

    constructor() {
        this.data = [];
        this.totalCount = 0;
    }
}

export interface VersionHistoryT3DataDto {
  isVersonHistory: boolean;
  overAssessmentId: number;
  summarydetailsId: string;
  versionNo: number;
  tab: number;
}
